import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'malbon_staff_toolkit_auth';

function readStoredAuth() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : { token: null, userInfo: null };
  } catch (_) {
    return { token: null, userInfo: null };
  }
}

export const AuthContext = createContext({
  token: null,
  userInfo: null,
  isAuthenticated: false,
  saveSession: () => {},
  clearSession: () => {},
});

export function AuthProvider({ children }) {
  const [session, setSession] = useState(() => readStoredAuth());

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  }, [session]);

  const saveSession = useCallback((nextSession) => {
    setSession({
      token: nextSession?.token ?? null,
      userInfo: nextSession?.userInfo ?? null,
    });
  }, []);

  const clearSession = useCallback(() => {
    setSession({ token: null, userInfo: null });
  }, []);

  const value = useMemo(
    () => ({
      token: session.token,
      userInfo: session.userInfo,
      isAuthenticated: Boolean(session.token),
      saveSession,
      clearSession,
    }),
    [session, saveSession, clearSession],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}


